import BaseRepository from "@/services/resources/repository";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema);
    }

    bySlug(slug) {
        const name = slug.replaceAll('-', ' ');

        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .where('name', name)
                    .first()
            )
        );
    }

    record(id) {
        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .include('service-service-categories')
                    .find(id)
            )
        );
    }
}

export default Repository;
